export default {
  pager: (state) => state.pager,
  bodycomposition: (state) => state.bodycomposition,
  measurements: (state) => state.measurements,
}
